// IssueContext.js
// import { TOKEN_KEY } from 'api';
import { getAll } from 'api/issues';
import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from './AuthContext';

const IssueContext = createContext();

export const IssueProvider = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const [state, setState] = useState({
    fetching: true,
    isLoading: false,
    issues: [],
    issuesStats: null
  });

  const getAllIssues = async () => {
    try {
      const { data } = await getAll();
      setState({
        fetching: false,
        issues: data.issues
      });
    } catch (err) {
      console.error(err);
    } finally {
      setState(st => ({
        ...st,
        fetching: false
      }));
    }
  };

  const updateIssue = (issue, orCreateIssue = false) => {
    if (orCreateIssue) {
      setState(st => {
        let tmp = st.issues.find(t => t.id === issue.id);

        if (!tmp)
          return {
            ...st,
            issues: [issue, ...st.issues]
          };
        else
          return {
            ...st,
            issues: st.issues.map(g => {
              return g.id === issue.id ? issue : g;
            })
          };
      });
    } else
      setState(st => ({
        ...st,
        issues: st.issues.map(g => {
          return g.id === issue.id ? issue : g;
        })
      }));
  };

  const deleteIssue = id => {
    setState(st => ({
      ...st,
      issues: st.issues.filter(el => el.id !== id)
    }));
  };

  useEffect(() => {
    if (isLoggedIn && user?.role === 'admin') {
      getAllIssues();
    } else {
      setState({
        fetching: true,
        isLoading: false,
        issues: [],
        issuesStats: null
      });
    }
  }, [isLoggedIn, user]);

  return (
    <IssueContext.Provider
      displayName='Issue Context'
      value={{
        isLoading: state.isLoading,
        fetching: state.fetching,
        issues: state.issues,
        issuesStats: state.issuesStats,
        deleteIssue,
        updateIssue
      }}
    >
      {children}
    </IssueContext.Provider>
  );
};

export const useIssues = () => useContext(IssueContext);
